import { Box, Collapse, Typography } from "@mui/material";
import { Expo } from "../../Models/Expo";
import { StyledExpoItem } from "./ExpoItem.styled";
import {
  CaretDownIcon,
  CaretLeftIcon,
  CheckIcon,
  TrashSimpleIcon,
  XIcon,
} from "@phosphor-icons/react";
import { useState } from "react";
import { SERVERURL } from "../../Globals/Constants";
import { useProfile } from "../../stores/useProfile";
import { useExpo } from "../../stores/useExpo";

type ExpoItemProps = {
  expo: Expo;
  onRemove: () => void;
};

export const ExpoItem = ({ expo, onRemove }: ExpoItemProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const { user } = useProfile();
  const {removeExpo} = useExpo();

  const handleRemove = async () => {
    if (!user) return;
    const res = await removeExpo(user, expo.id);
    if (res === 200) onRemove();
  }

  return (
    <StyledExpoItem>
      <Box className="expoItemHeader">
        <Typography variant="h3" onClick={() => setExpanded(!expanded)}>
          {expo.title}
        </Typography>
        <Box className="iconWrapper">
          {expanded ? (
            <CaretDownIcon size={32} weight="bold" onClick={() => setExpanded(!expanded)}/>
          ) : (
            <CaretLeftIcon size={32} weight="bold" onClick={() => setExpanded(!expanded)}/>
          )}
          {user && confirmation ? (
            <>
              <CheckIcon size={32} weight="bold" onClick={handleRemove}/>
              <XIcon size={32} weight="bold" onClick={() => setConfirmation(false) }/>
            </>
          ) : (
            user && <TrashSimpleIcon
              size={32}
              weight="bold"
              onClick={() => setConfirmation(true)}
            />
          )}
        </Box>
      </Box>
      <Collapse in={expanded}>
        <Box className="expoItemContent">
          {expo.files.map((file) => (
            <Box className="imageWrapper">
              <img src={`${SERVERURL}${file.filePath}`} alt={`art ${file.id}`}/>
            </Box>
          ))}
        </Box>
      </Collapse>
    </StyledExpoItem>
  );
};
